"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var type_1 = require("./util/type");
// todo: move whole project to @opten/initializer?
var Compiler = /** @class */ (function () {
    function Compiler(resolver) {
        this.resolver = resolver;
        this.componentCache = new Map();
    }
    Compiler.prototype.compile = function (component, node, componentType) {
        // todo: cache everything?
        var _this = this;
        // todo: cache that also?
        var constructor = new componentType(node);
        if (this.componentCache.has(node)) {
            this.componentCache.get(node).push(constructor);
        }
        else {
            this.componentCache.set(node, [constructor]);
        }
        Object.keys(component.queries).forEach(function (propName) {
            var query = component.queries[propName];
            // todo: why do we have to inject the resolver?
            // can we not get the class name by some other way?
            var target = _this.resolver.resolve(query.selector);
            if (target) {
                var targetNode = query.descendants ? node : document;
                var nodes = targetNode.getElementsByClassName(target.className);
                var cache = Array.from(nodes)
                    .filter(function (o) { return (query.filter ? query.filter(o) : true); })
                    .map(function (e) { return _this.componentCache.get(e); })
                    .reduce(function (acc, val) { return acc.concat(val); }, [])
                    .filter(function (f) { return f.constructor === query.selector; });
                constructor[propName] = query.first ? cache[0] : cache;
            }
        });
        if (type_1.isType(constructor.onInit)) {
            constructor.onInit();
        }
    };
    return Compiler;
}());
exports.Compiler = Compiler;
